import React, { useState, useEffect } from 'react'
import { Form, Col } from 'react-bootstrap'

const WAIT_INTERVAL = 1000;

const WorksheetTextbox = (props) => {
    const lg = props.colLg ? props.colLg : 9;
    const md = props.colMd ? props.colMd : 12;

    const [value, setValue] = useState('');
    const [timer, setTimer] = useState(null);

    useEffect(() => {
        setValue(props.value);
    }, [props.value])

    const handleChange = (e) => {
        clearTimeout(timer);
        setTimer(null);
        const value = e.target.value;
        const name = e.target.name;
        setValue(value)
        let localTimer = setTimeout(() => triggerChange({ target: { value: value, name: name } }), WAIT_INTERVAL);
        setTimer(localTimer);
    }

    const triggerChange = (e) => {
        props.onChangeInput(e);
        clearTimeout(timer);
        setTimer(null);
        console.log("Call to onChangeInput")
    }

    if (props.print) {
        return (
            <Form.Group as={Col} lg={lg} md={md}>
                <Form.Label>{props.label}</Form.Label><br />{props.value}
            </Form.Group>
        );
    } else {
        return (
            <Form.Group as={Col} lg={lg} md={md}>
                <Form.Label>{props.label}</Form.Label>
                <Form.Control placeholder=""
                    type="text"
                    name={props.name}
                    id={props.name}
                    value={value}
                    onBlur={props.onBlur}
                    isInvalid={props.error}
                    onChange={(e) => handleChange(e)} />
                <Form.Text className="text-muted">{props.description}</Form.Text>
                <Form.Control.Feedback type="invalid">
                    Initial and Revised values cannot be the same.
                </Form.Control.Feedback>
            </Form.Group>
        );
    }
}

export default WorksheetTextbox